module["exports"] = [
  "com",
  "biz",
  "info",
  "name",
  "net",
  "org",
  // Romanian
  "ro",
  "com.ro",
  "org.ro",
  "tm.ro",
  "store.ro",
  "info.ro",
  "nom.ro",
  "nt.ro",
  "firm.ro",
  "www.ro",
  "arts.ro",
  "rec.ro"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/ro/internet/domain_suffix.js
// module id = 3472
// module chunks = 1609